import { useCallback, useRef } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import PATHS from '@/common/paths';

export interface Body {
  qrId?: string;
  employeeId?: number;
  organizationId?: number;
  organizationPath?: string;
}

export interface CreatedDocument {
  document_id: number;
}
const useCreateDocumentByQRCodeQuery = () => {
  const controllerRef = useRef(new AbortController());

  const { mutateAsync, isLoading, isError, isSuccess } = useMutation((body: Body) => {
    controllerRef.current = new AbortController();
    return api.post<CreatedDocument>(PATHS.CREATE_DOCUMENT_BY_QR_CODE, {
      qr_id: body.qrId,
      employee_id: body.employeeId,
      // organization_id: body.organizationId,
      // organization_path: body.organizationPath,
    }, {
      signal: controllerRef.current.signal,
    });
  });

  const cancelCreateDocument = useCallback(() => {
    controllerRef.current.abort();
  }, []);

  return {
    createDocument: mutateAsync,
    cancelCreateDocument,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useCreateDocumentByQRCodeQuery;
